import './style.less';

export default function($log, $stateParams, RegulatorClass) {
  'ngInject';

  this.$onInit = () => {
    $log.debug('User License Edit Nav Loaded');

    RegulatorClass.loadRegulators()
      .then(({ objCurrent }) => {
        const { reg_id } = $stateParams;
        const regulator = objCurrent[reg_id] || {};
        const { extension, carry_over } = regulator.cycle_limiter || {};

        this.regulator = regulator;
        this.show_extension = !!extension;
        this.show_carry_over = !!carry_over;
      })
      .catch(error => {
        $log.error('User License Edit Nav Error', error);
        throw error;
      });
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/licenses/license/nav/index.js